import { Component, Input, OnInit } from "@angular/core";
import { OwlOptions } from "ngx-owl-carousel-o";
import { ToastrService } from "ngx-toastr";
import { BaseService } from "../../base.service";
import { forkJoin } from "rxjs";

@Component({
  selector: "app-popular-content",
  templateUrl: "./popular-content.component.html",
  styleUrls: ["./popular-content.component.css"],
})
export class PopularContentComponent implements OnInit {
  @Input() content: any;
  param = { limit: 7, offset: 0 };
  recommendedData: any = [];
  shimmerStatus = true;
  constructor(public service: BaseService, private toastr: ToastrService) {}
  recommended: OwlOptions = {
    loop: false,
    autoplay: false,
    mouseDrag: true,
    autoWidth: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    smartSpeed: 1,
    skip_validateItems: true,
    navText: ["", ""],
    responsive: {
      0: {
        items: 1.4,
      },
      380: {
        items: 2.2,
      },
      450: {
        items: 3.2,
      },
      650: {
        items: 4.2,
      },
      910: {
        items: 6.2,
      },
      1108: {
        items: 6.2,
      },
      1230: {
        items: 6.2,
      },
      1257: {
        items: 6.2,
      },
    },
    nav: true,
  };
  ngOnInit() {
    forkJoin({
      responseOne: this.service.recommended(this.param),
      responseTwo: this.service.mostPopular(this.param),
    }).subscribe(
      ({ responseOne, responseTwo }) => {
        this.shimmerStatus = false;
        if (responseOne.results.length > 0) {
          this.recommendedData = responseOne.results;
        } else {
          this.recommendedData = responseTwo.results;
        }
        if (this.recommendedData.length > 0) {
          this.service.contentPopular = false;
        }
      },
      (err) => {
        if (err) {
          this.shimmerStatus = false;
        }
      }
    );
  }
  playOff() {
    this.service.modelData = undefined;
    this.service.playerReady = false;
  }
}
